
import { defineComponent } from '@vue/runtime-core'
import {
  IonContent,
  IonHeader,
  IonItem,
  IonList,
  IonMenu,
  IonTitle,
  IonToolbar,
} from '@ionic/vue'
import { useI18n } from "vue-i18n";
import usePushLink from "@/composables/usePushLink";
import { useStore } from "vuex";

export default defineComponent({
  components: {
    IonContent,
    IonHeader,
    IonItem,
    IonList,
    IonMenu,
    IonTitle,
    IonToolbar,
  },
  props: {
    title: {
      type: String,
      default: 'menu.menu',
    },
    state: {
      type: Boolean,
      default: true,
    }
  },
  setup() {
    const { t } = useI18n()
    const { toPush } = usePushLink()
    const { dispatch } = useStore()

    const logOut = async ()=>{
      await dispatch('logOut')
    }

    return {
      t,
      toPush,
      logOut
    }
  },
})
